import React from 'react';
import { Chip, ChipProps } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';

interface StyledProps {
    labelFontSize?: number | string;
    labelFontWeight?: React.CSSProperties['fontWeight'];
}

interface StyledChipProps extends StyledProps, ChipProps {}

const useStyles = makeStyles<Theme, StyledProps>((theme) => ({
    chip: ({ labelFontSize, labelFontWeight }) => ({
        '& .MuiChip-label': {
            fontSize: labelFontSize ?? theme.typography.fontSize,
            fontWeight: labelFontWeight ?? theme.typography.fontWeightRegular,
        },
    }),
}));

const StyledChip: React.FC<StyledChipProps> = ({ labelFontSize, labelFontWeight, ...props }) => {
    const classes = useStyles({ labelFontSize, labelFontWeight });
    return <Chip className={classes.chip} {...props} />;
};

export default StyledChip;
